import { PartnerRefAngebotBeziehungRollen } from '@mng/sales-types';
import { IAntragFragen, IRollenFeatures } from './antrag-fragen';

const baseUvFragenDefs: IAntragFragen = {
  gesundheitsfragenG: new Set(),
  gesundheitsfragenCTFS: false,
  gesundheitsfragen: false,
  geldwaesche: false,
  sensibleDaten: true,
  bezugsrechtErleben: false,
  bezugsrechtAbleben: false,
  bezugsrechtKrankheit: false,
  paragraph_3_1_15: false,
  treuhaenderFrage: false,
  arbeitsStatusFrage: false,
  identifikationsnachweis: false,
  crsRelevant: true,
  fatcaGMSG: false,
  veranlagungBeratung: false,
  schriftformDatennutzung: true,
  bestattung: false,
  familienstand: false,
  geburtsland: false,
  berufsinfo: false,
  sozialVersDaten: false,
  adresse: true,
  nationalitaet: true,
  erhaltbasisInfoBlatt: true
};

export const uvRollenFeatures: IRollenFeatures[] = [
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERUNGSNEHMER,
    fragenDefs: baseUvFragenDefs
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERTE_PERSON_1,
    fragenDefs: {
      ...baseUvFragenDefs,
      berufsinfo: true,
      sozialVersDaten: true,
      nationalitaet: false,
      erhaltbasisInfoBlatt: false,
      uvPersonenFragen: true
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.PRAEMIENZAHLER,
    fragenDefs: { ...baseUvFragenDefs, sensibleDaten: false, crsRelevant: false, schriftformDatennutzung: false }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.GESETZLICHER_VERTRETER,
    fragenDefs: { ...baseUvFragenDefs, schriftformDatennutzung: false, sozialVersDaten: true }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.TREUGEBER,
    fragenDefs: baseUvFragenDefs
  }
];
